import { initTagging, pageViewDataLayer } from '@/utils/tagging-util'
import { useEffect } from 'react'

export default function usePageViewTag() {
  useEffect(() => {
    initTagging()
    pageViewDataLayer()
  }, [])
}
